/**
 * @flow
 * @format
 */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import _ from 'lodash';
import cc from 'classcat';
import { Col, Table } from 'reactstrap';

import { HashId } from '~/utils';

import classes from './PowerSemiLossSummary.scss';

type PropsType = {
  changed: boolean,
  changeInput: Function,
  defaultVal: number | string | null,
  fieldName: string | ReactElementType,
  tooltip: string | ReactElementType | ReactElementType[],
  error: string[],
  id: string,
  revertInput: Function,
  rowHeader: string[],
  value: number | string | null | string[][],
};

const hashId = new HashId();

// eslint-disable-next-line react/prefer-stateless-function
export class PowerSemiLossSummary extends React.Component<PropsType, *> {
  static defaultProps = {
    rowHeader: [],
    rowData: [],
  };

  props: PropsType;

  // shouldComponentUpdate(nextProps: PropsType) {
  //   const subProps = pick([
  //     'changed',
  //     'defaultVal',
  //     'error',
  //     'evaluating',
  //     'pos',
  //     'rowData',
  //     'value',
  //     'warning',
  //   ]);
  // //   return deepDiffer(subProps(this.props), subProps(nextProps));
  // }

  render() {
    const rowData: string[][] = _.slice((this.props.value: any), 2);

    const tRows = rowData.map((r: string[], k: number) => {
      const id = r[0];

      if (id.includes('Rthja')) {
        return (
          <tr key={id} className={cc([classes.partRow])}>
            <td>{r[0]}</td>
            <td colSpan={2} className={classes.lightBlue}>
              {r[1]}
            </td>
            <td colSpan={2}>{r[3]}</td>
          </tr>
        );
      }

      const rowClass = {
        [classes.partRow]: true,
        [classes.totalRow]: id.includes('Total'),
        [classes.maxRow]: id.includes('max'),
      };

      return (
        <tr key={id} className={cc([rowClass])}>
          {r.map((d: any, l: number) => {
            const c = {
              [classes.emptyRow]: l > 2 && !d.length,
              [classes.lightBlue]: l > 0 && l < 3,
            };

            return (
              <td key={hashId.encode(`${k}${l}`)} className={cc([c])}>
                {d}
              </td>
            );
          })}
        </tr>
      );
    });

    return (
      <Col>
        <div className="pt-2 pl-2 pr-2 d-flex">
          <strong>{this.props.fieldName}</strong>
          {this.props.tooltip}
        </div>
        <Table responsive size="sm" bordered className={classes.table}>
          <thead className="thead-inverse">
            <tr>
              <th className={classes.emptyRow} />
              <th colSpan={2} className={classes.blueHeader}>
                MOSFET
              </th>
              <th colSpan={2} className={classes.lightBlueHeader}>
                Diode
              </th>
            </tr>
            <tr>
              <th className={classes.emptyRow} />
              <th className={classes.blueHeader}>
                V<sub>IN</sub> min
              </th>
              <th className={classes.blueHeader}>
                V<sub>IN</sub> max
              </th>
              <th className={classes.lightBlueHeader}>
                V<sub>IN</sub> min
              </th>
              <th className={classes.lightBlueHeader}>
                V<sub>IN</sub> max
              </th>
            </tr>
          </thead>
          <tbody>{tRows}</tbody>
        </Table>
      </Col>
    );
  }
}

// function mapStateToProps(
//   state: AppStateType,
//   ownProps: OwnPropsType,
// ): PropsType {
//   const values = getFieldValues(state);
//   const data = values[ownProps.id];

//   // log(data);

//   const tableData: string[][] = _.get(data, ['currentValue'], []);
//   const rowData: string[][] = _.slice(tableData, 2);

//   return {
//     ...ownProps,
//     rowData,
//   };
// }

// const connector: Connector<OwnPropsType, PropsType> = connect(mapStateToProps);

export default PowerSemiLossSummary;



// WEBPACK FOOTER //
// ./src/components/TableGroup/PowerSemiLossSummary.js